import { render } from "./FooterToCareering.vue?vue&type=template&id=0278fe7c&bindings={\"transitionTo\":\"options\"}"
import script from "./FooterToCareering.vue?vue&type=script&lang=js"
export * from "./FooterToCareering.vue?vue&type=script&lang=js"

import "./FooterToCareering.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script